import { render } from "./OfferSelector.vue?vue&type=template&id=05afd4f5"
import script from "./OfferSelector.vue?vue&type=script&lang=js"
export * from "./OfferSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__